import React, { FC } from 'react';
import { VeksthusPanel } from './DefaultPanel';
import { BlinkPanel } from './BlinkPanel';

export type DeviceType = 'mobile' | 'tablet' | 'desktop';

export type AppProps = {
    blinkTraffic?: BlinkTraffic;
    defaultRender: boolean;
    deviceType: DeviceType;
};

export const App: FC<AppProps> = ({ defaultRender, deviceType, blinkTraffic }) => {
    if (defaultRender) return <VeksthusPanel deviceType={deviceType} />;

    return <BlinkPanel deviceType={deviceType} blinkTraffic={blinkTraffic} />;
};

interface HasTraffic {
    partnerName: string;
    productName: string;
    partnerLink: string;
}

export interface IncreasedTraffic extends HasTraffic {
    increasedTraffic: number;
    type: 'increased_traffic';
}

export interface LittleTraffic extends HasTraffic {
    type: 'little_traffic';
}

export interface NoTraffic {
    type: 'no_traffic';
}

export type BlinkTraffic = IncreasedTraffic | LittleTraffic | NoTraffic;
